import { render } from "./Activity.vue?vue&type=template&id=54c31f60"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
script.render = render

export default script